// Resolve a Pokémon type to its hex color by reading the --type-* CSS
// custom properties once and memoising. Type colors do not change between
// light and dark, so the cache is safe for the session.
const TYPES = [
  'normal',
  'fire',
  'water',
  'electric',
  'grass',
  'ice',
  'fighting',
  'poison',
  'ground',
  'flying',
  'psychic',
  'bug',
  'rock',
  'ghost',
  'dragon',
  'dark',
  'steel',
  'fairy',
];

let cache;

export function typeHex(type) {
  if (!cache) {
    cache = {};
    const cs = getComputedStyle(document.documentElement);
    for (const t of TYPES) {
      cache[t] = cs.getPropertyValue(`--type-${t}`).trim() || '#8a8f98';
    }
  }
  return cache[type] || '#8a8f98';
}
